import React from "react"
import ReactSelect from "react-select"
import ReactSelectAlias from "@components/objects/ReactSelectAlias/ReactSelectAlias"
import * as styles from "./SupplierSignupForm.module.scss"
import { discountOptions } from "@data/static"

const FormPricing = ({
  data,
  reactSelectStyles,
  handleChangeSelect,
  handleChange,
  priceOptions,
}) => (
  <section>
    <h3>Price</h3>
    <p>
      Any insight into pricing is extremely useful for our users and will help them match correctly
      with you and avoid wasting your time with unrealistic enquiries!
    </p>
    <div>
      <label htmlFor="pricesstartingfrom">Prices starting from:</label>
      <p>(Optional) please input a single figure or range here</p>
      <input
        id="pricesstartingfrom"
        name="pricesstartingfrom"
        onChange={handleChange}
        value={data.pricesstartingfrom}
        placeholder="e.g.  £500"
      />
    </div>
    <div>
      <label htmlFor="dayrate">Day rate:</label>
      <p>(Optional) please input a single figure or range here if helpful for people to know</p>
      <input
        id="dayrate"
        name="dayrate"
        onChange={handleChange}
        value={data.dayrate}
        placeholder="e.g.  £500"
      />
    </div>
    <div className="react-select-parent">
      <label htmlFor="pricerange">Price range*</label>
      <p>
        Please choose a price range that you feel best represents your business relative to your
        competitors and based on the guidelines provided below.
      </p>
      <div className={styles.reactSelect}>
        <ReactSelect
          styles={reactSelectStyles}
          className="react-select-container"
          id="pricerange"
          name="pricerange"
          onChange={handleChangeSelect}
          options={priceOptions}
          value={priceOptions.filter((v) => data.pricerange === v.value)}
        />
        <ReactSelectAlias value={data.pricerange} />
      </div>
    </div>
    <div>
      <label htmlFor="offer">
        Is there an exclusive offer you would provide for customers who book your services through
        HOPP?*
      </label>
      <p>
        This is a great way to entice users and boost enquires. It will also help you keep track of
        how well HOPP is working for you if clients are quoting a specific code to denote they found
        your business through HOPP
      </p>
      <ReactSelect
        styles={reactSelectStyles}
        className="react-select-container"
        id="offer"
        name="offer"
        isSearchable={false}
        onChange={handleChangeSelect}
        options={discountOptions}
        required
        value={discountOptions.filter((v) => data.offer === v.value)}
      />
      {data.offer === "other" ? (
        <div>
          <p>This could be a specific freebee or gift</p>
          <input
            id="offerother"
            name="offerother"
            onChange={handleChange}
            value={data.offerother}
          />
        </div>
      ) : null}
    </div>
  </section>
)

export default FormPricing
